import * as React from 'react';
import { useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBarcode, faBox  } from '@fortawesome/free-solid-svg-icons';
import { Typography, Grid, Card, CardContent, Avatar, Chip, TextField, MenuItem, Button, Tooltip, Box } from '@mui/material';
import { LocalizationProvider, DatePicker } from '@mui/x-date-pickers';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import 'moment/locale/es-mx';
import { esES as localeDate} from '@mui/x-date-pickers/locales'
import PrintIcon from '@mui/icons-material/Print';
import { FindInPage } from '@mui/icons-material';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import DescriptionIcon from '@mui/icons-material/Description';
import ModalCreacionGuia from '../../components/proveedores/ModalCreacionGuia';

function AdminGuias(){
    const [value, setValue] = React.useState(null);
    const [estatus, setEstatus] = React.useState('');

    useEffect(() => {
        document.title='Lilofy | Administración de Guías';
    }, [])

    const handleChangeEstatus = (event) => {
        setEstatus(event.target.value);
    };

    const [pageSize, setPageSize] = React.useState(5);
    const [openDialogGuia, setOpenDialog] = React.useState(null);
    const [anchorEl, setAnchorEl] = React.useState(null);

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
      };
    
      const handleClose = () => {
        setAnchorEl(null);
      };
    
      const openDialog = () => {
        setOpenDialog(true);
        handleClose();
      };
    
      const closeDialog = () => {
        setOpenDialog(null);
      };

    return(
        <>
        <LocalizationProvider dateAdapter={AdapterMoment } adapterLocale="es-mx" localeText={localeDate.components.MuiLocalizationProvider.defaultProps.localeText}>
            <div className='main-container'>
                <div className='mb-2 d-flex' style={{ alignItems: 'center' }}>
                    <Box sx={{ marginRight: '16px', fontSize: 25 }} color="primary.main">
                        <FontAwesomeIcon icon={faBox} />
                    </Box>
                    <Typography color='primary' variant='h4'>
                        Administración de guías
                    </Typography>
                </div>
                <Card className='card'>
                    <CardContent>
                        <Grid container direction={'row'} justifyContent="end" alignItems={"center"}>
                            <Grid item >
                                <Button onClick={openDialog}
                                    variant="contained">
                                    Nueva guía
                                </Button>
                            </Grid>
                        </Grid>
                        <Grid container columnSpacing={{ xs: 1, sm: 2, md: 3 }} direction={'row'} alignItems={"center"} mb={1}>
                            <Grid item sm={'auto'}>
                                <DatePicker
                                    label="Fecha inicio"
                                    value={value}
                                    renderInput={({ inputRef, inputProps, InputProps }) => (
                                        <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                            <TextField
                                                label="Fecha inicio"
                                                size="small"
                                                margin="normal"
                                                fullWidth
                                                ref={inputRef} {...inputProps}
                                            />
                                            {InputProps?.endAdornment}
                                        </Box>
                                    )}
                                />
                            </Grid>
                            <Grid item sm={'auto'}>
                                <DatePicker
                                    label="Fecha fin"
                                    value={value}
                                    renderInput={({ inputRef, inputProps, InputProps }) => (
                                        <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                            <TextField
                                                label="Fecha fin"
                                                size="small"
                                                margin="normal"
                                                fullWidth
                                                ref={inputRef} {...inputProps}
                                            />
                                            {InputProps?.endAdornment}
                                        </Box>
                                    )}
                                />
                            </Grid>
                            <Grid item sm={2}>
                                <TextField
                                    size="small"
                                    select
                                    fullWidth
                                    id="selectEstatus"
                                    value={estatus}
                                    label="Estatus"
                                    onChange={handleChangeEstatus}
                                >
                                    <MenuItem value={1}>Activo</MenuItem>
                                    <MenuItem value={2}>Inactivo</MenuItem>
                                </TextField>
                            </Grid>
                            <Grid item >
                                <Button
                                    variant="contained">
                                    Buscar
                                </Button>
                            </Grid>
                        </Grid>
                        <Grid container direction={'row'} justifyContent="end" alignItems={"center"}>
                            <Grid item>
                                <TextField
                                    size="small"
                                    margin="normal"
                                    fullWidth
                                    id="filter"
                                    label="Buscar"
                                    name="filter"
                                    />
                            </Grid>
                        </Grid>
                        
                        <Grid container spacing={2} >
                            <Grid item xs={12}>
                                <Card className="card card-button">
                                    <CardContent >
                                        <Grid container direction={'row'} spacing={2} columns={16} justifyContent="space-between">
                                            <Grid sm={2} item direction={'column'} alignItems="center" display={'flex'}>
                                                <Avatar sx={{ width: 50, height: 50, bgcolor: 'secondary.main', marginBottom:'5px' }} variant="rounded">
                                                    <FontAwesomeIcon icon={faBarcode} />
                                                </Avatar>
                                                <Chip label="Recibido" sx={{bgcolor: 'secondary.main', color: '#fff'}} />
                                                <Typography variant='subtitle' mt={2} className="text-center">
                                                    25/01/2023 03:25pm
                                                </Typography>
                                            </Grid>

                                            <Grid sm={2} item direction={'column'} alignItems="center" display={'flex'} justifyContent={'center'}>
                                                <Typography variant='h6'>
                                                    #123456789
                                                </Typography>
                                                <Typography variant='subtitle' mt={2}>
                                                    Cantidad de bultos: 5
                                                </Typography>
                                            </Grid>

                                            {/* <Grid item xs="auto" p={0}>
                                                <Divider orientation="vertical" flexItem/>
                                            </Grid> */}

                                            <Grid sm={4} item direction={'column'} display={'flex'} justifyContent={'center'}>
                                                <Typography variant='h6'>
                                                    El envío cambió de estatus
                                                </Typography>
                                            </Grid>

                                            <Grid sm={3} item direction={'column'} display={'flex'} justifyContent={'center'}>
                                                <Typography variant='h6'>
                                                    Descripción
                                                </Typography>
                                                <Typography variant='subtitle'>
                                                    Descripción que se capturó en la creación de la guía
                                                </Typography>
                                            </Grid>

                                            <Grid item sm={3} display={'flex'} justifyContent={'center'}>
                                                <Grid container direction={'column'} >
                                                    <Grid item direction={'column'} mb={2} >
                                                        <Typography variant='h6'>
                                                            Comentarios de transportista
                                                        </Typography>
                                                        <Typography variant='subtitle' mt={2}>
                                                            Sin comentarios
                                                        </Typography>
                                                    </Grid>
                                                    <Grid item direction={'column'}>
                                                        <Typography variant='h6'>
                                                            Fecha estimada de llegada
                                                        </Typography>
                                                        <Typography variant='subtitle' mt={2}>
                                                            Sin asignar
                                                        </Typography>
                                                    </Grid>
                                                </Grid>
                                            </Grid>

                                            <Grid sm={1} item container direction={'column'} display={'flex'} 
                                                justifyContent={'center'} >
                                                    <Tooltip title="Imprimir Guía" placement='top'>
                                                        <PrintIcon fontSize='large' sx={{marginBottom: '10px'}}/>
                                                    </Tooltip>
                                                    <Tooltip title="Ver Detalle" placement='top'>
                                                        <FindInPage fontSize='large'/>
                                                    </Tooltip>
                                            </Grid>
                                        </Grid>
                                    </CardContent>
                                </Card>
                            </Grid>

                            <Grid item xs={12}>
                                <Card className="card card-button">
                                    <CardContent >
                                        <Grid container direction={'row'} spacing={2} columns={16} justifyContent="space-between">
                                            <Grid sm={2} item direction={'column'} alignItems="center" display={'flex'}>
                                                <Avatar sx={{ width: 50, height: 50, bgcolor: 'primary.warning', marginBottom:'5px' }} variant="rounded">
                                                    <DescriptionIcon />
                                                </Avatar>
                                                <Chip label="Documentado" color="warning" />
                                                <Typography variant='subtitle' mt={2} className="text-center">
                                                    25/01/2023 03:25pm
                                                </Typography>
                                            </Grid>

                                            <Grid sm={2} item direction={'column'} alignItems="center" display={'flex'} justifyContent={'center'}>
                                                <Typography variant='h6'>
                                                    #123456789
                                                </Typography>
                                                <Typography variant='subtitle' mt={2}>
                                                    Cantidad de bultos: 5
                                                </Typography>
                                            </Grid>

                                            {/* <Grid item xs="auto" p={0}>
                                                <Divider orientation="vertical" flexItem/>
                                            </Grid> */}

                                            <Grid sm={4} item direction={'column'} display={'flex'} justifyContent={'center'}>
                                                <Typography variant='h6'>
                                                    El envío cambió de estatus
                                                </Typography>
                                            </Grid>

                                            <Grid sm={3} item direction={'column'} display={'flex'} justifyContent={'center'}>
                                                <Typography variant='h6'>
                                                    Descripción
                                                </Typography>
                                                <Typography variant='subtitle'>
                                                    Descripción que se capturó en la creación de la guía
                                                </Typography>
                                            </Grid>

                                            <Grid item sm={3} display={'flex'} justifyContent={'center'}>
                                                <Grid container direction={'column'} >
                                                    <Grid item direction={'column'} mb={2} >
                                                        <Typography variant='h6'>
                                                            Comentarios de transportista
                                                        </Typography>
                                                        <Typography variant='subtitle' mt={2}>
                                                            Sin comentarios
                                                        </Typography>
                                                    </Grid>
                                                    <Grid item direction={'column'}>
                                                        <Typography variant='h6'>
                                                            Fecha estimada de llegada
                                                        </Typography>
                                                        <Typography variant='subtitle' mt={2}>
                                                            Sin asignar
                                                        </Typography>
                                                    </Grid>
                                                </Grid>
                                            </Grid>

                                            <Grid sm={1} item container direction={'column'} display={'flex'} 
                                                justifyContent={'center'} >
                                                    <Tooltip title="Imprimir guía" placement='top'>
                                                        <PrintIcon fontSize='large' sx={{marginBottom: '10px'}}/>
                                                    </Tooltip>
                                                    <Tooltip title="Ver detalle" placement='top'>
                                                        <FindInPage fontSize='large'/>
                                                    </Tooltip>
                                            </Grid>
                                        </Grid>
                                    </CardContent>
                                </Card>
                            </Grid>

                            <Grid item xs={12}>
                                <Card className="card card-button">
                                    <CardContent >
                                        <Grid container direction={'row'} spacing={2} columns={16} justifyContent="space-between">
                                            <Grid sm={2} item direction={'column'} alignItems="center" display={'flex'}>
                                                <Avatar sx={{ width: 50, height: 50, bgcolor: 'primary.main', marginBottom:'5px' }} variant="rounded">
                                                    <LocalShippingIcon />
                                                </Avatar>
                                                <Chip label="En Tránsito" color="primary" />
                                                <Typography variant='subtitle' mt={2} className="text-center">
                                                    25/01/2023 03:25pm
                                                </Typography>
                                            </Grid>

                                            <Grid sm={2} item direction={'column'} alignItems="center" display={'flex'} justifyContent={'center'}>
                                                <Typography variant='h6'>
                                                    #123456789
                                                </Typography>
                                                <Typography variant='subtitle' mt={2}>
                                                    Cantidad de bultos: 5
                                                </Typography>
                                            </Grid>

                                            {/* <Grid item xs="auto" p={0}>
                                                <Divider orientation="vertical" flexItem/>
                                            </Grid> */}

                                            <Grid sm={4} item direction={'column'} display={'flex'} justifyContent={'center'}>
                                                <Typography variant='h6'>
                                                    El envío cambió de estatus
                                                </Typography>
                                            </Grid>

                                            <Grid sm={3} item direction={'column'} display={'flex'} justifyContent={'center'}>
                                                <Typography variant='h6'>
                                                    Descripción
                                                </Typography>
                                                <Typography variant='subtitle'>
                                                    Descripción que se capturó en la creación de la guía
                                                </Typography>
                                            </Grid>

                                            <Grid item sm={3} display={'flex'} justifyContent={'center'}>
                                                <Grid container direction={'column'} >
                                                    <Grid item direction={'column'} mb={2} >
                                                        <Typography variant='h6'>
                                                            Comentarios de transportista
                                                        </Typography>
                                                        <Typography variant='subtitle' mt={2}>
                                                            Sin comentarios
                                                        </Typography>
                                                    </Grid>
                                                    <Grid item direction={'column'}>
                                                        <Typography variant='h6'>
                                                            Fecha estimada de llegada
                                                        </Typography>
                                                        <Typography variant='subtitle' mt={2}>
                                                            Sin asignar
                                                        </Typography>
                                                    </Grid>
                                                </Grid>
                                            </Grid>

                                            <Grid sm={1} item container direction={'column'} display={'flex'} 
                                                justifyContent={'center'} >
                                                    <Tooltip title="Imprimir guía" placement='top'>
                                                        <PrintIcon fontSize='large' sx={{marginBottom: '10px'}}/>
                                                    </Tooltip>
                                                    <Tooltip title="Ver detalle" placement='top'>
                                                        <FindInPage fontSize='large'/>
                                                    </Tooltip>
                                            </Grid>
                                        </Grid>
                                    </CardContent>
                                </Card>
                            </Grid>

                            <Grid item xs={12}>
                                <Card className="card card-button">
                                    <CardContent >
                                        <Grid container direction={'row'} spacing={2} columns={16} justifyContent="space-between">
                                            <Grid sm={2} item direction={'column'} alignItems="center" display={'flex'}>
                                                <Avatar sx={{ width: 50, height: 50, bgcolor: 'success.main', marginBottom:'5px' }} variant="rounded">
                                                    <FontAwesomeIcon icon={faBox} />
                                                </Avatar>
                                                <Chip label="Entregado" color="success" />
                                                <Typography variant='subtitle' mt={2} className="text-center">
                                                    25/01/2023 03:25pm
                                                </Typography>
                                            </Grid>

                                            <Grid sm={2} item direction={'column'} alignItems="center" display={'flex'} justifyContent={'center'}>
                                                <Typography variant='h6'>
                                                    #123456789
                                                </Typography>
                                                <Typography variant='subtitle' mt={2}>
                                                    Cantidad de bultos: 5
                                                </Typography>
                                            </Grid>

                                            {/* <Grid item xs="auto" p={0}>
                                                <Divider orientation="vertical" flexItem/>
                                            </Grid> */}

                                            <Grid sm={4} item direction={'column'} display={'flex'} justifyContent={'center'}>
                                                <Typography variant='h6'>
                                                    El envío cambió de estatus
                                                </Typography>
                                            </Grid>

                                            <Grid sm={3} item direction={'column'} display={'flex'} justifyContent={'center'}>
                                                <Typography variant='h6'>
                                                    Descripción
                                                </Typography>
                                                <Typography variant='subtitle'>
                                                    Descripción que se capturó en la creación de la guía
                                                </Typography>
                                            </Grid>

                                            <Grid item sm={3} display={'flex'} justifyContent={'center'}>
                                                <Grid container direction={'column'} >
                                                    <Grid item direction={'column'} mb={2} >
                                                        <Typography variant='h6'>
                                                            Comentarios de transportista
                                                        </Typography>
                                                        <Typography variant='subtitle' mt={2}>
                                                            Sin comentarios
                                                        </Typography>
                                                    </Grid>
                                                    <Grid item direction={'column'}>
                                                        <Typography variant='h6'>
                                                            Fecha estimada de llegada
                                                        </Typography>
                                                        <Typography variant='subtitle' mt={2}>
                                                            Sin asignar
                                                        </Typography>
                                                    </Grid>
                                                </Grid>
                                            </Grid>

                                            <Grid sm={1} item container direction={'column'} display={'flex'} 
                                                justifyContent={'center'} >
                                                    <Tooltip title="Imprimir guía" placement='top'>
                                                        <PrintIcon fontSize='large' sx={{marginBottom: '10px'}}/>
                                                    </Tooltip>
                                                    <Tooltip title="Ver detalle" placement='top'>
                                                        <FindInPage fontSize='large'/>
                                                    </Tooltip>
                                            </Grid>
                                        </Grid>
                                    </CardContent>
                                </Card>
                            </Grid>
                        </Grid>
                    </CardContent>
                </Card>
            </div>

        </LocalizationProvider>

        <ModalCreacionGuia open={openDialogGuia === true} onClose={closeDialog}/>
        </>
    );
}

export default AdminGuias;